function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Utilities for dealing with map coordinates. */
import { FreeCameraOptions, MercatorCoordinate } from "mapbox-gl";
export function getMapPosition(map) {
  var pos = map.getFreeCameraOptions();
  var cameraPos = pos.position.toLngLat();
  var center = map.getCenter();
  return {
    camera: _objectSpread(_objectSpread({}, cameraPos), {}, {
      altitude: pos.position.toAltitude(),
      bearing: map.getBearing(),
      pitch: map.getPitch()
    }),
    target: _objectSpread(_objectSpread({}, center), {}, {
      zoom: map.getZoom()
    })
  };
}
export function setMapPosition(map, pos) {
  var _pos$target;

  var _pos$camera = pos.camera,
      _pos$camera$pitch = _pos$camera.pitch,
      pitch = _pos$camera$pitch === void 0 ? 0 : _pos$camera$pitch,
      _pos$camera$bearing = _pos$camera.bearing,
      bearing = _pos$camera$bearing === void 0 ? 0 : _pos$camera$bearing,
      altitude = _pos$camera.altitude;
  var zoom = (_pos$target = pos.target) === null || _pos$target === void 0 ? void 0 : _pos$target.zoom;

  if (zoom != null && altitude == null && pitch == 0 && bearing == 0) {
    var _pos$target2 = pos.target,
        lng = _pos$target2.lng,
        lat = _pos$target2.lat;
    map.setCenter([lng, lat]);
    map.setZoom(zoom);
  } else {
    var _pos$camera2 = pos.camera,
        _altitude = _pos$camera2.altitude,
        _lng = _pos$camera2.lng,
        _lat = _pos$camera2.lat;
    var cameraOptions = new FreeCameraOptions(MercatorCoordinate.fromLngLat({
      lng: _lng,
      lat: _lat
    }, _altitude), [0, 0, 0, 1]);
    cameraOptions.setPitchBearing(pitch, bearing);
    map.setFreeCameraOptions(cameraOptions);
  }
}